/* eslint-disable */



//return params array. pass null url will check location.href.
export function getUrlVars(url) {
  url = url || window.location.href;
  var vars = {};
  url.replace(/[?&]+([^=&]+)=([^&]*)/gi,    
  function(m,key,value) {
    vars[key] = value;
  });
  return vars;
}
export function saveSession(caller){
  var infoString = JSON.stringify(window.info)
  sessionStorage.setItem("globalVar", infoString)
  //console.log('saveSession:' + caller)
  window.info = JSON.parse(infoString)  //hack
}

export function loadSession(){
  var infoString = sessionStorage.getItem("globalVar")
  if ( infoString == null ){
    window.info = {}
  }
  else{
    window.info = JSON.parse(infoString)
  }
  //console.log('loadSession')
}


export function validateEngName(engName){
  var nameFormat = /^[A-Za-z\'\-\s]*?$/;
  if(nameFormat.test(engName)){
    return true;		
  }else{
    return false;
  }
}


export function validateEmail(email){
  var emailFormat = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  if(emailFormat.test(email)){
    return true;		
  }else{
    return false;
  }
}

export function validateDate(date)
{		
  var dateformat = /^(0[1-9]|[12][0-9]|3[01])[\/\-](0[1-9]|1[012])[\/\-]\d{4}$/;
  if(dateformat.test(date)){				
    var opera2 = date.split('-');	
    
    var lopera2 = opera2.length;
    if (lopera2>1){
      var pdate = date.split('-');				
    }else{				
      return false;
    }
    var dd = parseInt(pdate[0]);
    var mm  = parseInt(pdate[1]);
    var yy = parseInt(pdate[2]);
    var ListofDays = [31,28,31,30,31,30,31,31,30,31,30,31];
    if (mm==1 || mm>2){
      if (dd>ListofDays[mm-1]){					
        return false;
      }
    }
    if (mm==2){
      var lyear = false;
      if ( (!(yy % 4) && yy % 100) || !(yy % 400)) {
        lyear = true;
      }
      if ((lyear==false) && (dd>=29)){
        return false;
      }
      if ((lyear==true) && (dd>29)){					
        return false;
      }
    }
  }else{
    return false;
  }
  return true;
}


export function validateMobile(mobile){
  var mobileFormat = /^[0-9]{8,20}$/;
  if(mobileFormat.test(mobile)){
    return true;		
  }else{
    return false;
  }
}
export function getAge(DOB) {
  var today = new Date();
  var birthDate = new Date(DOB);
  birthDate.setDate(birthDate.getDate() - 1); //avoid timeszone issue
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
  }    
  return age;
}